<template>
  <div class="container-box">
    <div class="container-inner">
      <h2 class="title-type-1">
        매체 등록
        <span class="attention-coment-1">
          <v-icon>mdi-alert-circle</v-icon>
          매체 등록 후 지면을 추가하여 셋업할 수 있습니다!
        </span>
      </h2>

      <ul class="progress-step mb-10">
        <li class="active">
          <p class="state">
            <span class="num">1</span>
          </p>
          <p class="text">매체 기본정보</p>
        </li>
        <li>
          <p class="state">
            <span class="num">2</span>
          </p>
          <p class="text">지면 등록</p>
        </li>
      </ul>

      <v-form ref="form" v-model="valid">
        <!-- mediaLogo -->
        <h3 class="title-type-3">
          매체 로고 이미지
          <span class="required">
            <v-icon>mdi-check-circle-outline</v-icon>
            필수
          </span>
        </h3>

        <div class="form-group relative white rounded pa-6 mb-8">
          <div class="file-upload-box-1">
            <div class="file-thumb">
              <img v-if="file.thumb" :src="file.thumb" alt="" />
              <v-icon v-else>mdi-image-outline</v-icon>
            </div>
            <p class="form-coment-1 mt-3">
              <v-icon>mdi-alert-circle-outline</v-icon>
              40x40pix / *.png
            </p>
            <p class="file-name" v-if="file.name">
              {{ file.name }}
            </p>
            <div class="file-wrap">
              <v-btn
                large
                depressed
                max-height="32px"
                color="#fecd06"
                class="button-type-1"
                type="file"
              >
                파일 업로드
              </v-btn>
              <input type="file" @change="onFileChange" accept="image/png" />
            </div>
          </div>
        </div>
        <!-- //mediaLogo -->

        <!-- mediaName -->
        <h3 class="title-type-3">
          매체명
          <span class="required">
            <v-icon>mdi-check-circle-outline</v-icon>
            필수
          </span>
        </h3>
        <div class="relative white rounded pa-6 mb-8">
          <v-text-field
            class="input-custom-2"
            height="40px"
            v-model="mediaName"
            :rules="mediaNameRules"
            placeholder="20자 이내 입력해주세요"
            solo
            required
          ></v-text-field>
          <p class="form-coment-1 mt-n2">
            <v-icon>mdi-alert-circle-outline</v-icon>
            등록후 매체명은 변경이 불가합니다.
          </p>
        </div>
        <!--// mediaName -->

        <!-- form-wrap-->
        <div class="form-wrap">
          <div class="form-group mb-8">
            <h3 class="title-type-3">
              매체 타입
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6">
              <v-select
                :items="mediaTypeItems"
                label="선택"
                item-text="label"
                item-value="value"
                v-model="mediaType"
                @change="onChangeOption"
                :rules="mediaTypeRules"
                item-color="#000"
                class="input-custom-2"
                height="40px"
                solo
                required
              ></v-select>
            </div>
          </div>

          <div class="form-group mb-8">
            <h3 class="title-type-3">
              매체 상태
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6">
              <v-select
                :items="isValidItems"
                label="선택"
                item-text="label"
                item-value="value"
                v-model="isValid"
                :rules="isValidRules"
                item-color="#000"
                class="input-custom-2"
                height="40px"
                solo
                required
              ></v-select>
            </div>
          </div>
        </div>
        <!-- //form-wrap -->

        <!-- options -->
        <h3 class="title-type-3">
          지면 옵션 선택
          <span class="required">
            <v-icon>mdi-check-circle-outline</v-icon>
            필수
          </span>
        </h3>
        <div class="white rounded pa-6">
          <p class="text-type-1">
            등록할 매체의 지면들이 사용할 지면 특성만 선택하면 등록을 간편하게
            하실 수 있습니다.
          </p>
          <p class="form-coment-1 mt-2">
            <v-icon>mdi-alert-circle-outline</v-icon>
            지면 옵션 추가는 소스 개발 후 적용 가능합니다.
          </p>
          <div class="mt-6">
            <v-btn
              depressed
              max-height="32px"
              :color="isAllChecked ? '#eee' : '#fecd06'"
              class="button-type-1"
              @click.prevent="
                optionChx = (isAllChecked ? [] : options).map(o => o.id)
              "
            >
              {{ isAllChecked ? '선택 해제' : '전체 선택' }}
            </v-btn>
          </div>
          <ul class="chx-list-type-1 five border-top padding-right-type-1 mt-6">
            <li v-for="(option, index) in options" :key="index">
              <v-checkbox
                v-model="optionChx"
                :value="option.id"
                color="#fecd00"
                off-icon="mdi-checkbox-blank"
                class="checkbox-type-1"
                hide-details
              >
                <template v-slot:label>
                  {{ option.name }}
                  <v-tooltip right content-class="tooltip-custom-1">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ico-help-2 ml-1" v-bind="attrs" v-on="on"
                        >mdi-help-circle-outline</v-icon
                      >
                    </template>
                    <span>{{ option.note }}</span>
                  </v-tooltip>
                </template>
              </v-checkbox>
            </li>
          </ul>
        </div>
        <!-- //options -->

        <div class="d-flex justify-end mt-10">
          <v-btn
            large
            depressed
            min-width="104px"
            max-height="40px"
            color="#fff"
            class="button-type-1"
            @click.stop="cancel"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            min-width="104px"
            max-height="40px"
            color="#fecd06"
            class="button-type-1 ml-4"
            :disabled="
              !valid || !this.file.img || Object.keys(this.optionChx).length < 1
            "
            @click.prevent="registerMedias"
          >
            저장
          </v-btn>
        </div>
      </v-form>
    </div>

    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import { createMedia } from '@/api/media';
import { optionsList } from '@/api/options';
import { uploadWithNewPermission } from '@/api/etc';
import { constantMediaType2 as constantMediaType } from '@/utils/constant';

import SystemAlert from '~@/modal/SystemAlert.vue';

export default {
  components: { SystemAlert },
  data: () => ({
    valid: true,
    file: {
      img: null,
      name: null,
      thumb: null,
    },
    mediaName: '',
    mediaType: '',
    isValid: '',
    mediaTypeItems: Object.keys(constantMediaType).map(k => ({
      value: k,
      label: constantMediaType[k],
    })),
    isValidItems: [
      { value: 'Y', label: '운영중' },
      { value: 'N', label: '개발중' },
    ],
    mediaNameRules: [
      v => !!v || '매체명을 입력해주세요.',
      v => v.length <= 20 || '최대 20자까지 입력해주세요.',
    ],
    mediaTypeRules: [v => !!v || '매체 타입을 선택해주세요.'],
    isValidRules: [v => !!v || '매체 상태를 선택해주세요.'],
    allOptions: [],
    options: [],
    optionChx: [],
    resultType: '',
    mediaId: '',
    logResult: '',
    showSystemAlert: false,
  }),
  computed: {
    isAllChecked() {
      return this.options.length <= this.optionChx.length;
    },
  },
  methods: {
    async getOptions() {
      try {
        const { data } = await optionsList();
        this.allOptions = data.list;

        bus.$emit('end:spinner');
      } catch (error) {
        console.log(error.response);
        bus.$emit('end:spinner');
      }
    },
    onChangeOption() {
      this.options = this.allOptions.filter(
        o => o.media_type === this.mediaType || o.media_type === 'all',
      );

      this.optionChx = [];
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.file.name = file.name;
      this.file.thumb = URL.createObjectURL(file);
      this.file.img = file;
    },
    async registerMedias() {
      bus.$emit('start:spinner');
      try {
        // 로고를 골랐으면 저장 직전에 업로드하고, 실패하면 저장하지 않는다
        let logo;
        if (this.file.img) {
          try {
            logo = await uploadWithNewPermission('png', this.file.img);
          } catch (error) {
            console.log(error.response);
            bus.$emit('end:spinner');
            this.showSystemAlert = true;
            this.logResult =
              '이미지 업로드에 실패하였습니다. 다시 시도해주세요.';
            return;
          }
        }

        const mediaData = {
          logo: logo,
          name: this.mediaName.trim(),
          type: this.mediaType,
          is_valid: this.isValid,
          options: this.optionChx.map(id => ({ id })),
        };

        const { data } = await createMedia(mediaData);

        if (data.result === 'success') {
          bus.$emit('end:spinner');
          this.resultType = data.result;
          this.mediaId = data.value;
          this.showSystemAlert = true;
          this.logResult = '매체가 등록 되었습니다.';
        }
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
        const { data } = error.response;
        this.resultType = data.result;
        if (data.result === 'DuplicatedEntry') {
          this.showSystemAlert = true;
          this.logResult = '이미 사용중인 매체명이 있습니다.';
        } else if (data.result === 'ParameterValidation') {
          this.showSystemAlert = true;
          this.logResult = '등록에 실패하였습니다. 재등록 부탁드립니다.';
        }
      }
    },
    closePopup() {
      const type = this.resultType;
      this.showSystemAlert = false;
      if (type === 'success') {
        this.$router
          .push(`/media/v2/${this.mediaId}/inventoriesWrite`)
          .catch(() => {});
      }
    },
    cancel() {
      this.$refs.form.reset();
      this.$router.push({ name: 'media' }).catch(() => {});
    },
  },
  async created() {
    bus.$emit('start:spinner');
    await this.getOptions();
  },
};
</script>
